import { render, staticRenderFns } from "./TheFaqDrawer.vue?vue&type=template&id=dda1ebe4&"
import script from "./TheFaqDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheFaqDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports